module.exports = __webpack_public_path__ + "assets/img/21.147de45a.png";